import api from './axiosConfig';

/**
 * Ask a question to the AI assistant about inventory
 * @param {Object} params - The parameters for the question
 * @param {string} params.question - The question to ask
 * @param {Array<{question: string, answer: string}>} params.history - Prior Q&A pairs for context
 * @returns {Promise<Object>} - The AI assistant's response
 */
export const askInventoryQuestion = async ({
  question,
  history = []
}) => {
  try {
    const response = await api.post("/api/ai/ask", {
      question,
      history
    });
    return response.data;
  } catch (error) {
    console.error("Error asking inventory question:", error);
    throw error;
  }
};
